const storeTypes = {
  PRINT_SHIPPING: "PRINT AND SHIPPING",
};
export default storeTypes;
